export default {
  arrives: 'Anländer',
  journeyDuration: 'Reslängd',
}
